/* Add to cart for the "Shop the Look" upsell buttons (.atc-upsell-2-custom).

   These buttons used to simulate a click on the hidden submit button of the upsell
   product form. When the theme JS had not upgraded the <product-form> custom element
   yet (slow, blocked or erroring JS), that click fell through to a native top level
   POST to /cart/add, and because the variant id input can be empty Shopify answered
   with the full page error "Required parameter missing or invalid: items".

   This module never depends on a form submit: it resolves the selected variant from
   the block's own product JSON and posts it to /cart/add.js itself. No valid variant
   means the button simply stays disabled, so a malformed request can never be sent. */

(function () {
  'use strict';

  // A page can hold several shop the look sections, each of which requests this asset.
  if (window.upsellAddToCartLoaded) { return; }
  window.upsellAddToCartLoaded = true;

  var ITEM_SELECTOR = '.product-item-upsell';
  var BUTTON_SELECTOR = '.atc-upsell-2-custom';

  function routes() {
    return (window.themeVariables && window.themeVariables.routes) || {};
  }

  function settings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  function getProductData(item) {
    var form = item.querySelector('.product-form[data-product-json]');
    if (!form) { return null; }
    try {
      return JSON.parse(form.dataset.productJson);
    } catch (error) {
      return null;
    }
  }

  // Reads the selected value of every product option. The shop the look blocks render
  // options as .option-button elements, the cart upsell markup renders them as
  // <select id="option-<index>-<productid>" name="option-<index>"> - both are supported.
  function getSelectedOptions(item, productData) {
    return productData.options.map(function (option, index) {
      var optionButton = item.querySelector(
        '.option-group[data-option-index="' + index + '"] .option-button.selected'
      );
      if (optionButton) { return optionButton.dataset.value; }

      var select = item.querySelector(
        'select[name="option-' + index + '"], #option-' + index + '-' + productData.id
      );
      return select ? select.value : '';
    });
  }

  // Returns the selected variant, but only when it really exists and is in stock.
  function resolveVariant(item) {
    var productData = getProductData(item);

    // Products with a single variant have no option pickers, just the hidden id.
    if (!productData) {
      var input = item.querySelector('form [name="id"]');
      var id = input ? parseInt(input.value, 10) : NaN;
      return isNaN(id) ? null : { id: id };
    }

    var selectedOptions = getSelectedOptions(item, productData);
    var variant = productData.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selectedOptions[index];
      });
    });

    return variant && variant.available ? variant : null;
  }

  // A button is only clickable once this script runs and a valid, in stock variant
  // is selected.
  function syncButton(button) {
    var item = button.closest(ITEM_SELECTOR);
    button.disabled = !item || !resolveVariant(item);
  }

  function syncAllButtons(root) {
    (root || document).querySelectorAll(BUTTON_SELECTOR).forEach(syncButton);
  }

  function addToCart(button) {
    var item = button.closest(ITEM_SELECTOR);
    var variant = item ? resolveVariant(item) : null;

    // Nothing valid to add: keep the button disabled instead of firing a request.
    if (!variant) {
      button.disabled = true;
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch((routes().cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: variant.id, quantity: 1 }],
        sections: ['mini-cart']
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) { throw json; }
          return json;
        });
      })
      .then(function (json) {
        // Same events <product-form> dispatches, so the cart drawer, the item count
        // and every add to cart tracking listener (pixels included) keep working.
        button.dispatchEvent(
          new CustomEvent('variant:added', {
            bubbles: true,
            detail: { variant: json.items ? json.items[0] : json }
          })
        );

        return fetch((routes().cartUrl || '/cart') + '.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
            );

            cart['sections'] = json['sections'];

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: cart,
                  openMiniCart: settings().cartType === 'drawer' && button.closest('.drawer') === null
                }
              })
            );
          });
      })
      .catch(function (error) {
        console.error('Upsell add to cart failed:', error);
      })
      .then(function () {
        button.removeAttribute('aria-busy');
        syncButton(button);
      });
  }

  function init(root) {
    (root || document).querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      if (button.dataset.upsellAtcBound === 'true') { return; }
      button.dataset.upsellAtcBound = 'true';

      button.type = 'button'; // never behave as a submit button
      button.addEventListener('click', function (event) {
        event.preventDefault(); // never fall through to a full page /cart/add
        addToCart(button);
      });

      syncButton(button);
    });
  }

  // The option pickers are handled by the block's own script, so re-check the button
  // state after it had a chance to update the selection.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.closest && target.closest(ITEM_SELECTOR + ' .option-button')) {
      setTimeout(syncAllButtons, 0);
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target.closest && target.closest(ITEM_SELECTOR)) {
      setTimeout(syncAllButtons, 0);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})();
